import React from "react";
import cn from "classnames";
import Paper from "@material-ui/core/Paper";
import withStyles from "components/with-styles";
import DataGrid from "components/data-grid";
import styles from "./styles/page-header-bar-container.css.js";

const PageHeaderBarContainer = ({ children, classes }) => (
  <Paper elevation={2} className={cn(classes.page_header_bar, classes.page_header_bar_mainTitle)}>
    <DataGrid className={classes.page_header_bar_container}>{children}</DataGrid>
  </Paper>
);

export default withStyles(styles)(PageHeaderBarContainer);
